export default {
  ScrollToElement: {
    mounted() {
      this.handleEvent('scrollToElement', ({ id }) => document.getElementById(id).scrollIntoView());
    },
  },
};
